import { styled, Theme } from '@mui/material/styles'
import { Sidebar as RaSidebar, useSidebarState } from 'react-admin'

const enableSidebar = true

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Sidebar = props => {
  const [open] = useSidebarState()
  const styleProps = {
    open,
  }

  return enableSidebar ? (
    <StyledSidebar
      classes={classes}
      className={classes.root}
      size={200}
      {...props}
      {...styleProps}
    />
  ) : (<div />)
}

interface StyleProps {
  open?: boolean;
}

const PREFIX = 'xxllncSidebar'

const classes = {
  root: `${PREFIX}-root`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  fixed: `${PREFIX}-fixed`,
}

const StyledSidebar = styled(RaSidebar, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme, open }: StyleProps & { theme: Theme }) => ({
  [`&.${classes.root}`]: {
    display: 'none',
  },
  [`& .${classes.drawerPaper}`]: {
    border: 'none',
  },
  ['& .RaSidebar-fixed']: {
    boxSizing: 'border-box',
    overflowX: 'hidden',
    position: 'fixed',
    width: 'inherit',
    height: '100vh',
    paddingLeft: open ? theme.spacing(2) : 12,
    paddingRight: open ? theme.spacing(2) : 12,
    ['& .MuiBox-root']: {
      marginTop: 0,
    },
  },
}))

export default Sidebar
